import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import page1_section5 from "../../../assets/images/AboutVedaz/page1_section5.jpg";
import classes from "../AboutVedaz.styles";

interface Props {
  chapterIndex: number;
}

const DestinyAspect = ({ chapterIndex }: Props) => {
  const { t } = useTranslation();

  return (
    <Box>
      {/* ── Section 1: Background image ───────────────────────────── */}
      <Box sx={classes.bgSection}>
        <Box
          component="img"
          src={page1_section5}
          alt=""
          sx={classes.bgSectionMedia}
        />
        <Box sx={classes.bgSectionOverlay} />
        <Box sx={classes.bgSectionContent}>
          <Typography sx={classes.sectionHeading}>
            {t("about_destiny_heading")}
          </Typography>
          <Typography sx={{ ...classes.bodyText, maxWidth: "480px", mb: 0 }}>
            {t("about_destiny_s1_body")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default DestinyAspect;
